import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { CustomerUiRow } from '../types/customerTable.types'

type CustomerFormProps = React.ComponentProps<typeof RecordForm<CustomerUiRow>>

const CustomerForm = (props: CustomerFormProps) => <RecordForm<CustomerUiRow> {...props} />

export default CustomerForm
